import React from 'react';

import OutOfAppSidebarSubmenu from './OutOfAppSidebarSubmenu/OutOfAppSidebarSubmenu';
import UniversalNavLink from '../../UniversalNavLink';

import type { NavItem } from '../../../constants/links';

type OutOfAppLinksProps = {
  isCollapsed: boolean;
  navigationItems: Array<NavItem>;
};

const OutOfAppLinks = ({
  isCollapsed,
  navigationItems,
}: OutOfAppLinksProps) => {
  return (
    <React.Fragment>
      {navigationItems.map((navigationItem) => {
        let itemToRender;
        if (navigationItem.variant === 'link') {
          itemToRender = (
            <UniversalNavLink
              href={navigationItem.href}
              isCollapsed={isCollapsed}
              isSelected={false}
              isSidebar={true}
              text={navigationItem.text}
            />
          );
        }

        if (navigationItem.variant === 'product-2') {
          const heroAreaSubmenu = navigationItem.heroArea.submenu.map(
            (item) => {
              // Mapping over category submenus to remove descriptions
              const categorySubmenus = item.submenu?.map((categorySubmenu) => ({
                ...categorySubmenu,
                description: undefined,
              }));

              // Formats from all caps to all lowercase (except for first letter)
              const formattedCategoryTitle =
                item.text[0].toUpperCase() + item.text.slice(1).toLowerCase();

              return {
                href: null,
                submenu: categorySubmenus,
                text: formattedCategoryTitle,
              };
            }
          );

          const promoArea = {
            href: navigationItem.promoArea.header.href || null,
            text: navigationItem.promoArea.header.heading,
            submenu: navigationItem.promoArea.submenu.map((item) => {
              return {
                href: item.href || null,
                text: item.tag ? `${item.text} (${item.tag})` : item.text,
              };
            }),
          };

          const combinedSubmenus = [...heroAreaSubmenu, promoArea];

          itemToRender = (
            <OutOfAppSidebarSubmenu
              links={combinedSubmenus}
              text={navigationItem.text}
            />
          );
        }

        if (
          navigationItem.variant === 'variant-b' ||
          navigationItem.variant === 'variant-c'
        ) {
          itemToRender = (
            <OutOfAppSidebarSubmenu
              links={navigationItem.submenu}
              text={navigationItem.text}
            />
          );
        }

        return itemToRender ? (
          <li key={navigationItem.text} data-zds>
            {itemToRender}
          </li>
        ) : null;
      })}
    </React.Fragment>
  );
};

export default OutOfAppLinks;
